import { withInstall } from '../_util'

import StringInputInner from './StringInput/StringInput.vue'
import PasswordInputInner from './PasswordInput/PasswordInput.vue'
import TextareaInner from './Textarea/Textarea.vue'
import SingleSelectInner from './SingleSelect/SingleSelect.vue'
import MultiSelectInner from './MultiSelect/MultiSelect.vue'
import RadioGroupInner from './RadioGroup/RadioGroup.vue'
import CheckboxGroupInner from './CheckboxGroup/CheckboxGroup.vue'
import CheckboxInner from './Checkbox/Checkbox.vue'
import SwitchInner from './Switch/Switch.vue'
import DateInputInner from './DateInput/DateInput.vue'
import FileInputInner from './FileInput/FileInput.vue'
import LovInputInner from './LovInput/LovInput.vue'
import NumberInputInner from './NumberInput/NumberInput.vue'
import TableSelectInner from './TableSelect/TableSelect.vue'

export const StringInput = withInstall(StringInputInner)
export const PasswordInput = withInstall(PasswordInputInner)
export const Textarea = withInstall(TextareaInner)
export const SingleSelect = withInstall(SingleSelectInner)
export const MultiSelect = withInstall(MultiSelectInner)
export const RadioGroup = withInstall(RadioGroupInner)
export const CheckboxGroup = withInstall(CheckboxGroupInner)
export const Checkbox = withInstall(CheckboxInner)
export const Switch = withInstall(SwitchInner)
export const DateInput = withInstall(DateInputInner)
export const FileInput = withInstall(FileInputInner)
export const LovInput = withInstall(LovInputInner)
export const NumberInput = withInstall(NumberInputInner)
export const TableSelect = withInstall(TableSelectInner)

export * from './StringInput'
export * from './PasswordInput'
export * from './Textarea'
export * from './SingleSelect'
export * from './MultiSelect'
export * from './RadioGroup'
export * from './CheckboxGroup'
export * from './Checkbox'
export * from './Switch'
export * from './DateInput'
export * from './FileInput'
export * from './LovInput'
export * from './NumberInput'
export * from './TableSelect'
